export function normalizeUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  if (trimmed.startsWith('//')) {
    return 'https:' + trimmed;
  }

  if (trimmed.startsWith('www.')) {
    return 'https://' + trimmed;
  }

  return 'https://' + trimmed;
}
